<template>
  <div class="popup-new" data-popup="popup-1" id="verses-popup">
    <div class="popup-inner">
      <a class="popup-close" data-toggle="modal" data-target="#verses-popup" href="#"><img src="../../assets/cross.png"></a>
      <div class="tile">
        <feature-examples v-bind:feature="feature"></feature-examples>
      </div>
    </div>
  </div>
</template>
<script>

import FeatureExamples from './featureExamples.vue'

export default {
  name: 'versesPopup',
  components: { FeatureExamples },
  props: ['feature']
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/experiment/versesPopup.vue